/* eslint-disable import/prefer-default-export */
import environment from "environment";
import qs from "qs";
import type { Filters, Sorting } from "@fas/ui-framework";
import { requestService } from "./request";
import type { Page } from "../components/PagesList/types/PagesList.types";

type GetPagesListResponse = {
  data: {
    data: {
      pagesList: Array<Page>;
      count: number;
    };
  }
};

export const getPagesList = async (options: {
  page: number,
  pageSize: number,
  filters: Filters;
  sorting: Sorting;
// eslint-disable-next-line max-len
}): Promise<GetPagesListResponse> => requestService.get(environment.endpoints.get.documentsList, {
  params: { ...options },
  paramsSerializer: (params: any) => qs.stringify(params, { arrayFormat: "brackets", encode: false }),
});

export const archivePage = (documentId: string): Promise<any> => requestService
  .post(environment.endpoints.post.archivePage.replace("{documentId}", documentId), {});

export const bulkView = (previewData: Array<string>): Promise<any> => requestService
  .get(environment.endpoints.get.documentsViewAll, {
    params: { previewData },
  });

export const bulkDelete = (id: Array<string>): Promise<any> => requestService
  .delete(environment.endpoints.delete.documentsAll, {
    data: { id },
  });
